import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import IntersectionObserverWrapper from '@cinch/oxd-components/intersection-observer-wrapper/src'
import VehicleCard from '@cinch/oxd-components/dealer-vehicle-card/src'
import { actions as profileActions, selectors as profileSelectors } from '@cinch/oxd-redux/profile/src'
import { actions as vehicleActions, selectors as vehicleSelectors } from '@cinch/oxd-redux/dealer-vehicles/src'
import { trackVehicleDisplay } from '@cinch/oxd-utils/analytics/src'

import { Location, VehicleCardProps } from '@cinch/oxd-components/dealer-vehicle-card/src/vehicle-card.component'

interface DispatchProps {
  onSave: (v: boolean) => any
  fetchData: (location?: Location) => any
}

type OwnProps = { id: number } & Pick<VehicleCardProps, 'isUnfavourited' | 'linkToProductView' | 'hasCompareButton'>
type StateProps = Pick<VehicleCardProps, 'isPending' | 'isAvailable' | 'isSaved' | 'userLocation' | 'vehicle'>

export const mapStateToProps = (state: any, { id }: OwnProps) => {
  const isPending: boolean = vehicleSelectors.getPredicate(state).listingsStatus.isPending
  const vehicle: Cinch.DealerVehicleAdvertSummary = vehicleSelectors.getListingById(state)(id)
  const isAvailable = true
  const isSaved = profileSelectors.isVehicleFavourited(state)(id)
  const userLocation = profileSelectors.getLocation(state)

  return {
    isPending,
    isAvailable,
    isSaved,
    userLocation,
    vehicle,
  } as StateProps
}

export const mapDispatchToProps = (dispatch: Dispatch<any>, { id }: OwnProps) => {
  return {
    onSave: (isSaved) => dispatch(isSaved ? profileActions.addFavourite(id) : profileActions.removeFavourite(id)),
    fetchData: (userLocation: Location = { latitude: null, longitude: null, location: '', distance: 0 }) => {
      const { latitude, longitude } = userLocation

      return dispatch(vehicleActions.getSummary(id, latitude, longitude))
    },
  } as DispatchProps
}

export const Component: React.FC<
  OwnProps &
    VehicleCardProps & {
      fetchData?: (location?: Location) => any
      className?: string
      children?: (props: VehicleCardProps) => React.ReactNode
    }
> = ({ fetchData, userLocation, id, className = '', vehicle, ...props }) => {
  const hasData = !!(vehicle && vehicle.vehicleId)

  React.useEffect(() => {
    if (!hasData && fetchData) {
      fetchData(userLocation)
    }
  }, [hasData])

  const handleIntersection = (isVisible: boolean, initialLoad: boolean) => {
    trackVehicleDisplay(id.toString(), isVisible, initialLoad)
  }

  return (
    <IntersectionObserverWrapper className={className} onIntersection={handleIntersection}>
      <VehicleCard {...props} vehicle={vehicle} />
    </IntersectionObserverWrapper>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
